import { Dialog } from "primereact/dialog";
import { ShowPurchaseOrder } from "../showPurchaseOrder";

interface IProps {
    open: boolean,
    singleData: any,
    po: any,
    hideDialog: () => void
}

export const MyProjects = (props: IProps) => {
    const onHide = () => {
        props.hideDialog();
    }
    return (
        <>
            <Dialog visible={props.open} style={{ width: "80vw" }} header="My Projects" modal className="p-fluid" onHide={onHide}>
                <ShowPurchaseOrder is_Consultant={true}/>
            </Dialog>
        </>
    );
}